import { Button, PageHeader } from 'antd';
import { FC, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import DiscountFilter from '../components/filters/discount-filter';
import DiscountsTable from '../components/tables/discounts-table';

const DiscountsListRoute: FC = () => {
  const [filters, setFitlers] = useState()
  const navigate = useNavigate()

  return (<>
    <PageHeader
      title="تخفیف ها"
      style={{ padding: " 16px 0" }}
      extra={[
        <Button key="add"><Link to="/discounts-form">افزودن</Link></Button>,
      ]}
      onBack={() => navigate(-1)}
    />
    <DiscountFilter onFinish={setFitlers} />
    <DiscountsTable filters={filters} />
  </>);
}

export default DiscountsListRoute;
